import React from "react";
import GameInstructionModal from "../GameInstructionModal";

const BlueRedRandomObstacleModal = ({ isOpen, onRequestClose }) => {
  return (
    <GameInstructionModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      title="Random Obstacle (Red/Blue)"
      gamePath="/userDashboard/game/red-and-blue-randomobstacle"
      icon="solar:bomb-bold"
      instructions={[
        "Wear red and blue glasses.",
        "Press the Spacebar to jump over incoming random obstacles on the screen."
      ]}
      isBinocular={true}
    />
  );
};

export default BlueRedRandomObstacleModal;
